/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
// @ts-ignore: No overload matches this call

import { Field, ErrorMessage } from 'formik'
import Text from '../Text'
import FlexLayout from '../FlexLayout'
import { fieldStyle, fieldDisabledStyle, FieldLabel } from './style'

interface FormFieldProps {
  label: any
  name: any
  fieldRef?: any
  isDisabled?: any
  fieldType?: any
  style?: any
  styleContainer?: any
  styleLabel?: any
  onBlur?: any
  onKeyUp?: any
  onKeyPress?: any
  onKeyDown?: any
  inputType?: any
  onChange?: any
  adornment?: any
  autoComplete?: any
  testId?: string
}

function FormField({
  label = ' ',
  name,
  fieldRef,
  isDisabled = false,
  fieldType = 'text',
  style,
  styleContainer,
  styleLabel,
  onBlur,
  onKeyUp,
  onKeyPress,
  onKeyDown,
  inputType = 'input',
  onChange,
  adornment,
  autoComplete,
  testId,
}: FormFieldProps) {
  // @ts-ignore
  const errorMessage = <ErrorMessage component={Text as any} name={name} style={{ color: 'red' } as any}/>

  return (
    <FlexLayout
      direction={(styleContainer && styleContainer.flexDirection) ? styleContainer.flexDirection : 'column'}
      {...((styleContainer && styleContainer.justifyContent) && { justify: styleContainer.justifyContent })}
      {...((styleContainer && styleContainer.alignItems) && { align: styleContainer.alignItems })}
      style={{ width: 'auto', margin: '15px 5px 0 0', ...styleContainer }}
    >
      <Text textType='defaut' text={label} style={styleLabel}/>
      <FieldLabel>
        <Field
          data-testid={testId}
          name={name}
          innerRef={fieldRef}
          as={inputType}
          type={fieldType}
          style={{
            ...fieldStyle,
            ...style,
            ...(isDisabled ? fieldDisabledStyle : ''),
            paddingLeft: '6px',
          }}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          disabled={isDisabled}
          autoComplete={autoComplete}
          {...(onBlur && { onBlur })}
          {...(onChange && { onChange })}
          {...(onKeyPress ? { onKeyPress } : {
            onKeyPress: (event) => {
              if (event.key === 'Enter') {
                // let nextInput = document.getElementsByName(event.target.name)[0].parentElement.nextSibling.getElementsByTagName('input')[0];
                const submitButton = document.querySelector('.submit-button') as any
                const button = document.querySelector('button')
                const inputs = document.getElementsByTagName('input') as any
                const activeInputs = [...inputs].filter((input) => !input.disabled)

                for (let index = 0; index < inputs.length; index++) {
                  if (activeInputs[index] === document.getElementsByName(event.target.name)[0]) {
                    if (index === activeInputs.length - 1) {
                      if (submitButton != null) submitButton.click()
                      else if (button != null) button.click()
                      break
                    }
                    activeInputs[index + 1].focus()
                  }
                }
              }
            },
          }
            )}
        />
        {adornment}
      </FieldLabel>
      {errorMessage}
    </FlexLayout>
  )
}

export default FormField
